import { nanoid } from 'nanoid';

export const ANNOTATIONS_MARKER = 'ANNOTATIONS_MARKER';

export type AnnotationDragDescriptor = {
  id: number;
  left: number;
  top: number;
};
export type Annotation = {
  id: string;
  position: number[];
  text: string;
};

const RAW_REGEX = /(.+?)\((.+?)\|(.*?)\)([\s\S]*)$/g;

export const splitRawAnnotation = (raw: string) => {
  try {
    const rawMatch = [...raw.matchAll(RAW_REGEX)];
    const match = rawMatch[0];
    const a = {
      id: match[1],
      position: [parseFloat(match[2]), parseFloat(match[3])],
      text: match[4],
    } as Annotation;
    return a;
  } catch (_e) {
    /* do nothing */
    return;
  }
};

export const rawToAnnotation = splitRawAnnotation;
export const annotationToRaw = (anno: Annotation) => `${anno.id}(${anno.position[0]}|${anno.position[1]})${anno.text}`;

export const createNewAnnotation = () =>
  ({
    id: nanoid(),
    position: [50, 50],
    text: '<p>Lorem ipsum</p>',
  }) as Annotation;
export const createNewRawAnnotation = () => annotationToRaw(createNewAnnotation());
